export const storyIds = ['plan', 'log', 'remember', 'connect', 'feed'] as const;

export type StoryId = (typeof storyIds)[number];

export function isStoryId(value: string): value is StoryId {
  return storyIds.includes(value as StoryId);
}

export function storyIndex(id: StoryId): number {
  return storyIds.indexOf(id);
}

export function closestStoryId(entries: ReadonlyArray<{ id: string; ratio: number }>, fallback: StoryId): StoryId {
  return entries.reduce<{ id: StoryId; ratio: number }>(
    (best, entry) =>
      isStoryId(entry.id) && entry.ratio > best.ratio ? { id: entry.id, ratio: entry.ratio } : best,
    { id: fallback, ratio: -1 },
  ).id;
}
